import React, {useState } from 'react'
import { getAuth, createUserWithEmailAndPassword,signInWithEmailAndPassword } from "firebase/auth";
import "./Log.css"
import app from '../Firebase/firebase';

export default function Log() {
  const auth = getAuth(app);

  const [email, setEmail]=useState ("")
  const [password, setPassword]=useState ("")

  const signup = () => {
  createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      console.log(user);
      alert("Successfully created an account")
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      // const errorMessage = error.message;
      alert(errorCode)
      // ..
    });
  }
  
  const signin = () => {
    signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    console.log(user);
    alert("This user has successfully signed in")
    // ...
  })
  .catch((error) => {
    const errorCode = error.code;
    alert(errorCode)
    // const errorMessage = error.message;
  });

  }
  return (
    <> 
    <div className='mt-5 text-center text-white'>
    <h1>Sign up</h1>
    <div className="Form mt-5 "> 
       {/* <h1>Sign up</h1> */}
        <div className="Main">
          <label> Email:- </label> <br />
          <input className='vishal'
            style={{ color: "white" }}
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <br />
          <br />
          <label> Password:- </label> <br />
          <input
            placeholder="Password"
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <br />
          <br />
          <button className='bo' type="submit" onClick={signup}>
            Create Account
          </button>
          <br />
          <button className='but' onClick={signin}> sign in</button>
        </div>
      </div>
    </div>
    
        
    
    </>
  )
}
